import { render, staticRenderFns } from "./FieldAccidentType.vue?vue&type=template&id=3484e886&"
import script from "./FieldAccidentType.vue?vue&type=script&lang=js&"
export * from "./FieldAccidentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3484e886')) {
      api.createRecord('3484e886', component.options)
    } else {
      api.reload('3484e886', component.options)
    }
    module.hot.accept("./FieldAccidentType.vue?vue&type=template&id=3484e886&", function () {
      api.rerender('3484e886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldAccidentType.vue"
export default component.exports